import * as Sentry from '@sentry/sveltekit';
import { browser } from '$app/environment';
import { PUBLIC_ENV, PUBLIC_SENTRY_DSN, PUBLIC_SENTRY_ENABLED } from '$env/static/public';

Sentry.init({
  enabled: PUBLIC_SENTRY_ENABLED === 'true' && window.localStorage.getItem('errorLogging') !== '0',
  dsn: PUBLIC_SENTRY_DSN,
  tracesSampleRate: 1,
  includeLocalVariables: true,
  environment: PUBLIC_ENV,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  maxValueLength: 25000,
  normalizeDepth: 25000,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error', 'assert'],
    }),
  ],
});

if (browser) {
  Sentry.setUser({ id: <string>window.localStorage.getItem('metriAddress') ?? '' });
  Sentry.setContext('user', {
    metri_address: window.localStorage.getItem('metriAddress'),
    pay_address: window.localStorage.getItem('payAddress'),
  });

  Sentry.setTag('metri_address', window.localStorage.getItem('metriAddress'));
  Sentry.setTag('pay_address', window.localStorage.getItem('payAddress'));
}

export const handleError = Sentry.handleErrorWithSentry();
